<template>
  <div class="functional">
    <div class="switch-btn"></div>
    <div class="onpen-font">开放功能</div>
    <div class="features-content" v-if="getSecond">
      <div class="item-panel" v-for="item in getSecond.value" :key="item.label">
        <router-link tag="a" target="_blank" :to="item.link">
          <img :src="item.imgfile" height="80" />
          <span class="item-title">{{ item.title }}</span>
          <span class="des-info">{{ item.text }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getSecond: "home/getSecond"
    })
  }
};
</script>

<style lang="less" scoped>
.functional {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: @color-font-white;
  .switch-btn {
    height: 54px;
  }
  .onpen-font {
    height: 166px;
    line-height: 166px;
    font-size: 36px;
    color: @color-font-primary;
  }
  .features-content {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    margin-bottom: 60px;
    .item-panel {
      width: 300px;
      // height: 302px;
      text-align: center;
      padding: 25px 46px 20px 46px;
      span {
        display: block;
      }

      img {
        margin-bottom: 28px;
      }

      .item-title {
        font-size: 24px;
        color: @color-primary;
        letter-spacing: 0;
        line-height: 24px;
        margin-bottom: 40px;
      }
      .des-info {
        font-size: 16px;
        color: @color-font-primary;
        letter-spacing: 0;
        line-height: 21px;
        text-align: left;
      }
    }
  }
}
</style>
